// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 973) return "static/chunks/973.819cd3bfba4d915e.js";
	if (chunkId === 5288) return "static/chunks/5288.d2239988b16eeb00.js";
	if (chunkId === 9153) return "static/chunks/9153.6f7f2c7c74f62995.js";
	if (chunkId === 2252) return "static/chunks/2252.e1138cf2450f8aed.js";
	if (chunkId === 6722) return "static/chunks/6722.0b2235274fd3567a.js";
	if (chunkId === 4035) return "static/chunks/4035.cf1549d778e4e4d5.js";
	if (chunkId === 9842) return "static/chunks/9842.77331228ec58e0b7.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3234":"73979989","6671":"5db719f2"}[chunkId] || chunkId) + "-" + {"3234":"976abcd4b32c06ff","3800":"d595979b9c837baf","4232":"a8f73a4f68c22acf","5407":"78720fd9e562bca1","5605":"b92b281506418ce6","6671":"ab57c74bbe208720","7120":"655b27401c9793e0","8220":"415bb3e62e32d44c"}[chunkId] + ".js";
};